<template>
  <div>
    <form class="">
      <div class="fieldSet">
        <h3 v-if="bubbleTitle">{{bubbleTitle}}</h3>
        <div class="field">
          <label>{{$t('profile.currentPassword')}}</label>
          <input v-model="updatePasswordRequest.password_actual" :type="inputType">
          <ErrorMessage v-if="updateErrors.errors?.password_actual !== undefined">{{$t('errors.invalidCurrentPassword')}}</ErrorMessage>
        </div>
        <div class="field">
          <label>{{$t('profile.newPassword')}}</label>
          <input v-model="updatePasswordRequest.password" :type="inputType">
          <ErrorMessage v-if="updateErrors.errors?.password !== undefined">{{$t('errors.invalidNewPassword')}}</ErrorMessage>
        </div>
        <div class="field">
          <label>{{$t('profile.passwordConfirmation')}}</label>
          <input v-model="updatePasswordRequest.password_confirmation" :type="inputType">
          <ErrorMessage v-if="updatePasswordRequest.password !== updatePasswordRequest.password_confirmation">
            {{$t('profile.passwordShouldBeSame')}}
          </ErrorMessage>
        </div>
        <a href="#" class="bt btG" @click.prevent="switchPasswordVisibility"><i :class="eyeIcon"/></a>
        <a href="#" :class="cancelButtonClass" @click.prevent="cleanInputs">{{$t('profile.cancel')}}</a>
        <a href="#" :class="confirmButtonClass" @click.prevent="save">{{$t('profile.confirm')}} <i class="fa fa-check"/></a>
      </div>
    </form>
    <toast ref="toastMessage">{{ $t('profile.dataUpdated') }}</toast>
  </div>
</template>
<script setup lang="ts">
import {ref, computed} from 'vue'
import type {UpdateUserPasswordErrors, UpdateUserPasswordRequest} from "~/api/generated";
import api from "~/api";

const updatePasswordRequest = ref<UpdateUserPasswordRequest>({
  password: '',
  password_actual: '',
  password_confirmation: ''
})

const updateErrors = ref<UpdateUserPasswordErrors>({})
const toastMessage = ref(null)
const cancelButtonClass = computed(() => {
  return updatePasswordRequest.value.password_actual ? 'bt btG' : 'bt btG disabled'
});
const confirmButtonClass = computed(() => {
  return checkAllInputs() ? 'bt' : 'bt disabled'
});
const showPassword = ref(false)
const eyeIcon = computed(()=>{
  return showPassword.value ? 'fa fa-eye' : 'fa fa-eye-slash'
})
const inputType = computed(() => {
  return showPassword.value ? 'text' : 'password'
})
defineProps({
  bubbleTitle: String,
})

onMounted(async () => {
})

async function save() {
  try {
    await api.User.updatePassword(updatePasswordRequest.value)
    toastMessage.value?.activate(1.5)
    cleanInputs();
    setTimeout(() => {
          window.location = '/'
        },
        3000
    );
  } catch (error: AxiosError) {
    if (error.response.status === 422) {
      updateErrors.value = error.response.data
    }
  }
}

function checkAllInputs() {
  return updatePasswordRequest.value.password_actual &&
      updatePasswordRequest.value.password &&
      updatePasswordRequest.value.password_confirmation
}

function cleanInputs() {
  updatePasswordRequest.value = {
    password: '',
    password_actual: '',
    password_confirmation: ''
  }
  updateErrors.value = {}
}

function switchPasswordVisibility() {
  showPassword.value = !showPassword.value
}
</script>
